import React from 'react';
import axios from 'axios';
import { Card, Button, Avatar,Modal,Spin,Form,Input,Select,message,Switch,Result,DatePicker } from 'antd';
import AccountUpdateForm from './AccountUpdateForm'
import { UserOutlined,LoadingOutlined } from '@ant-design/icons';
import { PlusOutlined } from '@ant-design/icons';
import { Drawer,Divider } from 'antd';
import * as serverconfig from '../serverconn'
import {
  Col,
  Row,
} from 'reactstrap';

const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const FormItem=Form.Item;
const { Option } = Select;
const { TextArea } = Input;
const dateFormat = 'DD/MM/YYYY';

var token= ''

class CompleteAction extends React.Component{

    state={
        account: {},
        datarequested:true,
        applicant_action:{},
        required_fields:[],
        submitted_data:[],
        actionID:'',

        file_attachments:[],
        datasubmittedsuccessfully:false,

    }

    componentDidMount(){
      if(localStorage.getItem("api_token")){
         token= localStorage.getItem("api_token")
      }else{
         token= ''
      }

      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

        const action_ID=this.props.match.params.actionID;
        this.setState({actionID:action_ID})
        axios.get(`${serverconfig.backendserverurl}/api/applicant_actions/${action_ID}`)
        .then(res => { 

            this.setState({
              applicant_action: res.data
            })


            //get required fields
            let form_data = new FormData();
            form_data.append('required_fields', res.data.required_fields);     
            //Register the account first
            axios.post(serverconfig.backendserverurl+'/customqueries/get_action_datafields',form_data)
            .then(res =>{
              this.setState({required_fields:res.data.report})
      
            })
          .catch(error => console.log(error))

        })
        this.setState({datarequested:false})

     }

      //sample exists
      isitem_added = (item_name, list) => {
        return list.some((item) => item.label === item_name);
      };
  


    uploadImages=(application_id)=>{
        //////////////////////////////
      ///// UPLOAD FILES
      this.state.file_attachments.forEach((item) => {
        const { value: file, label } = item; // Destructure `value` and `label` for clarity
        console.log("File: "+label)
        if (file) {
          const formData = new FormData();
          formData.append("file_name", label);
          formData.append("application", application_id);
          formData.append("file", file, file.name || "");
      
          axios
            .post(`${serverconfig.backendserverurl}/customqueries/update_application_file`, formData, {
              headers: { "content-type": "multipart/form-data" },
            })
            .then((res) => {
              console.log(`File uploaded successfully for label: ${label}`);
            })
            .catch((error) => {
              console.error(`Error uploading file for label: ${label}`, error);
            });
        } else {
          console.log(`No file to upload for label: ${label}`);
        }
        
      });   

  } 


    render(){

      if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin  size="large">
                <div className="content" />
              </Spin>     
          </div>
        )
  
      }else{


        if(this.state.datasubmittedsuccessfully===true){
            return(
              <div>
                  <Card>
                    <Result
                    status="success"
                    title="Successfully Submitted Response."
                    extra={[
                      <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
                    ]}
                    />
                  </Card>
              </div>
            )
    
          }else{
            return(
                <div>
                  <Card 
                    style={{padding:10}}
                    hoverable>
                    <h3>You are requested to make these Submissions.</h3>
      
                    {
                      this.state.required_fields.length>0?
                      <div>
                      {
                       this.state.required_fields.map((field)=>{
                          var label=field.label
                          var field_type=field.field_type
                          var is_required=field.is_required
                          var options=JSON.parse(field.options)  
      
                          //map value now
                          if (field_type==="text"){
      
                              return (
      
                              <FormItem label={label}
                              name={label}
      
                                  rules={[
                                      {
                                          required:is_required===true?true:false,
                                          message: 'Please select',
                                      },
                                      ]}
                                  >
                                      <Input 
                                      placeholder={label} 
                                      onChange={(val)=>{
                                          //add to data list now
                                          var dataobj={
                                              'key':this.state.submitted_data.length+1,
                                              'value':val.target.value,
                                              'label':label,
                                              'field_type':field_type
      
                                          }
      
                                          //check item existence in data
                                          if (this.isitem_added(label,this.state.submitted_data)){
                                              const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                              let newArray = [...this.state.submitted_data]
                                              newArray[elementsIndex] = {...newArray[elementsIndex], 
                                                  "value":val.target.value,
                                              }
                                              this.setState({
                                                  submitted_data: newArray,
                                              });
      
                                          }else{
                                              var new_array = [
                                              ...this.state.submitted_data,
                                              dataobj,
                                              ];
                                              this.setState({ submitted_data: new_array });
                                          }
      
                                      }}
                                      />
          
                                  </FormItem>
                              )
      
                          }
      
                          if (field_type==="textarea"){
                              var value=''
      
                              return (
      
                              <FormItem label={label}
                                  name={label}
                                  rules={[
                                      {
                                          required:is_required===true?true:false,
                                          message: 'Please select',
                                      },
                                      ]}
                                  >
                                      <TextArea
                                          placeholder={label} 
                                          autoSize={{ minRows: 2, maxRows: 6 }}
                                          onChange={(val)=>{
                                              value=val.target.value
                                              //add to data list now
                                              var dataobj={
                                                  'key':this.state.submitted_data.length+1,
                                                  'value':val.target.value,
                                                  'label':label,
                                                  'field_type':field_type
                                              }
      
                                          //check item existence in data
                                          if (this.isitem_added(label,this.state.submitted_data)){
                                              const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                              let newArray = [...this.state.submitted_data]
                                              newArray[elementsIndex] = {...newArray[elementsIndex], 
                                                  "value":val.target.value,
                                              }
                                              this.setState({
                                                  submitted_data: newArray,
                                              });
      
                                          }else{
                                              var new_array = [
                                              ...this.state.submitted_data,
                                              dataobj,
                                              ];
                                              this.setState({ submitted_data: new_array });
                                          }
                                          
                                          }}
                                      />
                                  </FormItem>
                              )
      
                          }
      
      
                          if (field_type==="number"){
                            return (
      
                              <FormItem label={label}
                              name={label}
      
                                  rules={[
                                      {
                                          required:is_required===true?true:false,
                                          message: 'Cant be empty',
                                      },
                                      ]}
                                  >
                                      <Input 
                                      placeholder={label} 
                                      type='number'
                                      onChange={(val)=>{
                                          //add to data list now
                                          var dataobj={
                                              'key':this.state.submitted_data.length+1,
                                              'value':val.target.value,
                                              'label':label,
                                              'field_type':field_type
                                          }
      
                                          //check item existence in data
                                          if (this.isitem_added(label,this.state.submitted_data)){
                                              const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                              let newArray = [...this.state.submitted_data]
                                              newArray[elementsIndex] = {...newArray[elementsIndex], 
                                                  "value":val.target.value,
                                              }
                                              this.setState({
                                                  submitted_data: newArray,
                                              });
      
                                          }else{
                                              var new_array = [
                                              ...this.state.submitted_data,
                                              dataobj,
                                              ];
                                              this.setState({ submitted_data: new_array });
                                          }
      
                                      }}
                                      />
          
                                  </FormItem>
                              )
      
      
                          }
      
                          if (field_type==="date"){
                            return (
      
                              <FormItem label={label}
                                  name={label}
                                  rules={[
                                      {
                                          required:is_required===true?true:false,
                                          message: 'Cant be empty',
                                      },
                                      ]}
                                  >
      
                                  <DatePicker 
                                  onChange={(date, dateString)=>{
                                    
                                    this.setState({ expiry_date: dateString})
                                  
                                    //add to data list now
                                    var dataobj={
                                      'key':this.state.submitted_data.length+1,
                                      'value':dateString,
                                      'label':label,
                                      'field_type':field_type
                                  }
      
                                  //check item existence in data
                                  if (this.isitem_added(label,this.state.submitted_data)){
                                      const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                      let newArray = [...this.state.submitted_data]
                                      newArray[elementsIndex] = {...newArray[elementsIndex], 
                                          "value":dateString,
                                      }
                                      this.setState({
                                          submitted_data: newArray,
                                      });
      
                                  }else{
                                      var new_array = [
                                      ...this.state.submitted_data,
                                      dataobj,
                                      ];
                                      this.setState({ submitted_data: new_array });
                                  }
                                  
                                  
                                  }}
                                  format={dateFormat} 
                                  
                                  />
      
                                  </FormItem>
                              )
      
      
                          }
      
      
                          if (field_type==="file"){
      
                            return (
                          <Form.Item label={label}>
                                <Input
                                  type="file"
                                  accept=".pdf"
                                  placeholder="PDF"
                                  onChange={(e) => {
                                    const file = e.target.files[0]; // Retrieve the selected file
                                    const dataobj = {
                                      key: this.state.file_attachments.length + 1,
                                      value: file,
                                      label: label,
                                    };
      
                                    // Check if item already exists in file_attachments
                                    const existingIndex = this.state.file_attachments.findIndex(
                                      (element) => element.label === label
                                    );
      
                                    if (existingIndex !== -1) {
                                      // Update the existing item
                                      const updatedAttachments = [...this.state.file_attachments];
                                      updatedAttachments[existingIndex] = { ...updatedAttachments[existingIndex], value: file };
                                      this.setState({ file_attachments: updatedAttachments });
                                    } else {
                                      // Add new item
                                      this.setState((prevState) => ({
                                        file_attachments: [...prevState.file_attachments, dataobj],
                                      }));
                                    }
                                  }}
                                />
                              </Form.Item> 
      
                            )
      
                          }
      
      
                          if (field_type==="select"){
      
                              return (
      
                              <FormItem label={label}
                                  name={label}
                                  rules={[
                                      {
                                          required:is_required===true?true:false,
                                          message: 'Please select',
                                      },
                                      ]}
                                  >
                                  <Select 
                                  placeholder={label}
                                  style={{  }} 
                                  onChange={(val)=>{
                                      value=val
                                      //add to data list now
                                      var dataobj={
                                          'key':this.state.submitted_data.length+1,
                                          'value':val,
                                          'label':label,
                                          'field_type':field_type
      
                                      }
                                      
                                  //check item existence in data
                                  if (this.isitem_added(label,this.state.submitted_data)){
                                      const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                      let newArray = [...this.state.submitted_data]
                                      newArray[elementsIndex] = {...newArray[elementsIndex], 
                                          "value":val,
                                      }
                                      this.setState({
                                          submitted_data: newArray,
                                      });
      
                                  }else{
                                      var new_array = [
                                      ...this.state.submitted_data,
                                      dataobj,
                                      ];
                                      this.setState({ submitted_data: new_array });
                                  }
      
      
                                  }} 
                                  showSearch
                                  optionFilterProp="children"
                                  onFocus={this.onFocus}
                                  onBlur={this.onBlur}
                                  onSearch={this.onSearch}   
                                  >
                                  {
                                      options.map((itm)=>{
                                          return(
                                              <Option value={itm.value}>{itm.label}</Option>
      
                                          )
                                      })
                                  }
                                  </Select>
                                  </FormItem>
                              )
      
                          }
      
                          if (field_type==="checkbox"){
      
                            return (
                              <Form.Item label={label} >
                                <Switch
                                    onChange={val=>{
                                    
                                          //add to data list now
                                          var dataobj={
                                            'key':this.state.submitted_data.length+1,
                                            'value':val,
                                            'label':label,
                                            'field_type':field_type
                                        }
      
                                        //check item existence in data
                                        if (this.isitem_added(label,this.state.submitted_data)){
                                            const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                            let newArray = [...this.state.submitted_data]
                                            newArray[elementsIndex] = {...newArray[elementsIndex], 
                                                "value":val,
                                            }
                                            this.setState({
                                                submitted_data: newArray,
                                            });
      
                                        }else{
                                            var new_array = [
                                            ...this.state.submitted_data,
                                            dataobj,
                                            ];
                                            this.setState({ submitted_data: new_array });
                                        }
      
                                    
                                    }}
                                    checkedChildren="Yes"
                                    unCheckedChildren="No"
                                    />
                              </Form.Item>
                            )
                          }
                      })}
      
                  </div>
                  :
                  null
                }
      
      
                  <Form.Item>
                    <Button type="primary" htmlType="button" 
                     onClick={()=>{
                      let form_data = new FormData();
                      form_data.append('actionID', this.state.actionID);
                      form_data.append('submitted_data', JSON.stringify(this.state.submitted_data));
                      
                      //Register the account first
                      axios.post(serverconfig.backendserverurl+'/customqueries/applicant_action_response',form_data)
                      .then(res =>{
                        message.success(res.data.message)
                        this.setState({datarequested:false})
      
                        var application_id=res.data.application_id
                        console.log("Application ID: "+application_id)
                
                        //upload images
                        this.uploadImages(application_id);
      
                        this.setState({datasubmittedsuccessfully:true})
            
                       // window.location.reload(false)
                
                      })
                      .catch(error => console.log(error))
                
                    }}>
                    Submit 
                    </Button>
                 </Form.Item>
                          
                  </Card>
                </div>
            )

          }





      }
       
    }
}

export default CompleteAction; 